export default __webpack_public_path__ + "static/media/C3.c0dee6a9.mp3";